import { 
  Card, 
  CardHeader, 
  CardBody, 
  Heading, 
  VStack, 
  Box, 
  Text,
  Badge,
  Divider
} from '@chakra-ui/react';

export interface CompanyPerspective {
  company: string;
  sentiment: string;
  talking_points: string;
}

interface CompanyPerspectivesProps {
  perspectives: CompanyPerspective[];
}

export const CompanyPerspectives = ({ perspectives }: CompanyPerspectivesProps) => {
  // Ensure perspectives is an array
  const safePerspectives = perspectives || [];
  
  if (safePerspectives.length === 0) return null;
  
  return (
    <Card>
      <CardHeader>
        <Heading size="md">Company Perspectives</Heading>
      </CardHeader>
      <CardBody>
        <VStack spacing={4} align="stretch" divider={<Divider />}>
          {safePerspectives.map((perspective, index) => (
            <Box key={index} data-testid="company-perspective-item">
              <Text fontWeight="bold">{perspective.company}</Text>
              <Badge 
                colorScheme={getSentimentColor(perspective.sentiment)} 
                mb={2}
              >
                {perspective.sentiment}
              </Badge>
              <Text>{perspective.talking_points}</Text>
            </Box>
          ))}
        </VStack>
      </CardBody>
    </Card>
  );
};

// Helper function to determine color based on sentiment
function getSentimentColor(sentiment: string): string {
  const lowerSentiment = sentiment.toLowerCase();
  if (lowerSentiment.includes('positive') || lowerSentiment.includes('bullish')) return 'green';
  if (lowerSentiment.includes('negative') || lowerSentiment.includes('bearish')) return 'red';
  if (lowerSentiment.includes('neutral')) return 'gray';
  if (lowerSentiment.includes('mixed')) return 'purple';
  if (lowerSentiment.includes('cautious')) return 'yellow';
  return 'blue'; // default
} 